<template>
    <div class="user-index">
      <!-- 微信认证组件 -->
      <wxAuth :share="share" ref="child"></wxAuth>
      <!-- title -->
      <headers :params="hraderP"></headers>
      <div class="top-banner">
        <van-swipe :autoplay="3000" :height="105">
          <van-swipe-item v-for="(banner, index) in bannerList" :key="index">
            <img :src="banner" :onerror="defaultImg" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="owner-info">
        <div class="owner-info-logo">
          <img :src="owner.firmIcon | getImageUrl" onerror="this.src='//image10.homedo.com/sitefiles/b2b/Images/Nopic.jpg'" />
        </div>
        <div class="owner-info-detail">
          <div class="owner-name">{{owner.firmName}}</div>
          <div class="owner-count">
            <div class="owner-identification"><img :src="renzhengIcon" /><span>认证品牌商</span></div>
            <div class="owner-count-num" v-if="owner.clickCount">人气<span>{{owner.clickCount}}</span></div>
          </div>
        </div>
      </div>

      <div class="public-header">
        <div class="public-header-left">联系方式</div>
      </div>
      <div class="contact-info">
        <div class="contact-public-list">
          <div class="contact-public-list-t">联系人</div>
          <div>{{owner.contact?owner.contact: '-'}}</div>
        </div>
        <div class="contact-public-list">
          <div class="contact-public-list-t">联系方式</div>
          <div>{{owner.contactMobile?owner.contactMobile:'-'}}</div>
        </div>
        <div class="contact-public-list">
          <div class="contact-public-list-t">联系邮箱</div>
          <div>{{owner.contactEmail?owner.contactEmail: '-'}}</div>
        </div>
      </div>

      <template v-if="owner.firmIntroduction">
        <div class="public-header" >
          <div class="public-header-left">简介</div>
        </div>
        <div class="introduction">
          <div class="introduction-wrap" v-html="owner.firmIntroduction"></div>
        </div>
      </template>

      <div class="public-header" v-if="params1.list.length>0">
        <div class="public-header-left">方案</div>
      </div>
      <solList :params="params1"></solList>

      <div class="public-header" v-if="params2.list.length>0">
        <div class="public-header-left">资讯</div>
      </div>
      <newsList :params="params2"></newsList>
    </div>
</template>

<script>
import headers from '@/components/headers'
import { getUserInfo } from '@/api/user/user'
import { getSolution } from '@/api/solutions/solution'
import { getColumnList } from '@/api/news/news'
import list from '@/components/list'
import renzhengIcon from '@/assets/images/renzheng_icon.png'
import indexBanner from '@/assets/images/index_banner.png'
import { getImageUrl } from '@/filters/commonFilters'
import wxAuth from '@/components/wxAuth'
export default {
  name: 'index',
  filters: { getImageUrl },
  components: {
    solList: list,
    newsList: list,
    wxAuth,
    headers
  },
  data () {
    return {
      userId: '',
      owner: {},
      renzhengIcon,
      indexBanner,
      defaultImg: 'this.src="' + require('@/assets/images/index_banner.png') + '"',
      params1: {
        list: [],
        type: 'sol'
      },
      params2: {
        list: [],
        type: 'info',
        label: 'true'
      },
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '品牌主主页',
        lefticon: true
      },
      bannerList: []
    }
  },
  mounted () {
    this.getUrlParams()
    this.getUserInfo()
  },
  watch: {
    $route (from, to) {
      this.getUrlParams()
      this.getUserInfo()
    }
  },
  methods: {
    // 获取路由参数
    getUrlParams () {
      this.userId = this.$route.params.id
    },
    // 初始函数
    getUserInfo () {
      // 根据UserID 查询品牌主详情
      getUserInfo(this.userId).then(res => {
        if (res.data.code === 200) {
          this.owner = Object.assign({}, res.data.data)
          if (!res.data.data.firmBanner) {
            this.bannerList.push(indexBanner)
          } else {
            this.bannerList = this.owner.firmBanner.split('||')
          }
          if (this.owner) {
            this.share.title = this.owner.firmName
            this.share.desc = this.owner.firmIntroduction
            this.share.imgUrl = getImageUrl(this.owner.firmIcon)
            if (this.share.imgUrl.indexOf('https') < 0) {
              this.share.imgUrl = 'https:' + this.share.imgUrl
            }
            this.$refs.child.wxAuth()
          }
        }
      })

      const data = {
        pageNum: 1,
        pageSize: 5,
        userId: this.userId
      }
      // 查询相关方案
      getSolution(data).then(res => {
        if (res.data.code === 200) {
          this.params1.list = [...res.data.data.list]
        }
      })

      // 查询相关资讯
      getColumnList(data).then(res => {
        if (res.data.code === 200) {
          this.params2.list = [...res.data.data.list]
        }
      })
    }
  }
}
</script>

<style lang="scss">
.user-index {
  .top-banner {
    width: 100%;
    height: 105px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      display: inline-block;
      vertical-align: middle;
    }
    &-label {
      position: absolute;
      left: 15px;
      top: 10px;
      font-size: 15px;
      color: #fff;
      z-index: 1;
    }
  }
  .owner-info {
    display: flex;
    height: 85px;
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
    &-logo {
      width: 55px;
      height: 55px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
        display: inline-block;
        vertical-align: middle;
        border-radius: 4px;
        border: 1px solid #d8d8d8;
      }
    }
    &-detail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 3px 0;
      margin-left: 10px;
      .owner-name {
        color: #222;
        font-size: 15px;
      }
      .owner-count {
        display: flex;
        color: #faa528;
        font-size: 10px;
        .owner-identification {
          display: flex;
          align-items: center;
          img {
            display: inline-block;
            width: 10px;
            height: 13px;
            margin-right: 2px;
            vertical-align: middle;
          }
        }

        &-num {
          margin-left: 10px;
          padding-left: 10px;
          border-left: 1px solid #d1d1d1;
          color: #a0a0a0;
          span {
            color: #1cbfda;
            margin-left: 3px;
          }
        }
      }
    }
  }
  .contact-public-list {
    height: 45px;
    margin-left: 15px;
    border-bottom: 1px solid #e5e5e5;
    font-size: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    color: #333;
    &:last-child {
      border-bottom: none;
    }
    &-t {
      width: 90px;
      color: #888;
    }
  }

  .contact-info, .introduction, .solution {
    background-color: #fff;
  }
  .introduction-wrap {
    padding: 15px 25px;
    font-size: 13px;
    color: #666;
    img {
      max-width: 100% !important;
      height: auto !important;
    }
    div, span, p, strong {
      font-size: 14px!important;
      line-height: 1.5 !important;
      color: #666 !important;
      word-break: break-all;
    }
    h1,h2,h3,h4,h5,h6 {
      font-size: 16px!important;
      line-height: 1.5;
      color: #222 !important;
      word-break: break-all;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/user/index.vue